/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Value entry in a legend block. A many-to-one mapping is necessary to AnalyticLegend.
 */
export interface AnalyticLegendEntry { 
    /**
     * Internal AnalyticLegendEntry Key
     */
    id: number;
    /**
     * Internal AnalyticLegend Key
     */
    analyticLegendId: number;
    /**
     * Sort order of the legend entry
     */
    sort: number;
    /**
     * Property value of the legend entry
     */
    propertyValue: string;
    /**
     * Property text of the legend entry
     */
    propertyText: string;
}

